var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"19","height":"19","rx":"9.5","fill":"#1E5662","stroke":"#288195"}})])}
var staticRenderFns = []

export { render, staticRenderFns }